import React, { ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserModel } from "../apis/types";
import { datadogRum } from "@datadog/browser-rum";
import { ACCESS_TOKEN, IS_HIDE_TOP_BAR } from "../utils/constants";
import { CourtBookingApi } from "../apis/bookingapi";

type CourtBookingContextType = {
  isAuthenticated?: boolean | null;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
  onLogOut: (isNoAccessToken?: boolean) => void;
  fetchMe: (callback?: any) => Promise<void>;
  userModel: UserModel | undefined;
};

const CourtBookingContext = React.createContext<CourtBookingContextType>({
  setIsAuthenticated: (isAuthenticated: boolean) => {},
  onLogOut: (isNoAccessToken?: boolean) => {},
  fetchMe: async () => {},
  userModel: undefined,
});

type CourtBookingProviderProps = {
  children: ReactNode | ReactNode[];
};

function CourtBookingProvider(props: CourtBookingProviderProps) {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [userModel, setUserModel] = useState<UserModel>();

  const navigate = useNavigate();

  useEffect(() => {
    fetchMe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onLogOut = (isNoAccessToken?: boolean) => {
    navigate(
      isNoAccessToken
        ? "/get-started?utm_content=no_access_token"
        : "/get-started"
    );
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(IS_HIDE_TOP_BAR);
    setUserModel(undefined);
    setIsAuthenticated(false);
    // deleteFCMToken();
  };

  const fetchMe = async (callback?: () => null) => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    setIsAuthenticated(!!token);
    if (token) {
      const user = await CourtBookingApi.getMe();
      setUserModel(user);
      datadogRum.setUser({ id: user.userId });
    }
  };

  return (
    <CourtBookingContext.Provider
      value={{
        setIsAuthenticated,
        onLogOut,
        isAuthenticated,
        fetchMe,
        userModel,
      }}
      {...props}
    />
  );
}

function useCourtBooking() {
  const context = React.useContext(CourtBookingContext);

  if (context === undefined) {
    throw new Error("useCoach must be used within a CoachProvider");
  }
  return context;
}

export { CourtBookingProvider, useCourtBooking };
